export var selectDimension = function selectDimension(dashboardState, dimensionName) {
  for (var tableIndex = 0; tableIndex < dashboardState.data.tables.length; tableIndex++) {
    var currentTable = dashboardState.data.tables[tableIndex];

    for (var dimensionIndex = 0; dimensionIndex < currentTable.dimensions.length; dimensionIndex++) {
      var currentDimension = currentTable.dimensions[dimensionIndex];
      if (currentDimension.name === dimensionName) return currentDimension;
    }
  }

  return null;
};